import { createContext, useContext } from "react";
import createTranslate, { type Translate } from "./createTranslate";

// English by default, so a component rendered without the provider (stories,
// the standalone RewardsButton) still shows text.
const TranslationsContext = createContext<Translate>(createTranslate("en"));

const useTranslations = () => useContext(TranslationsContext);

export default useTranslations;
export { TranslationsContext };
